export * from './classes';
export * from './color-picker.directive';
export * from './color-picker.module';
export * from './color-picker.service';



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/~/angular4-color-picker/lib/index.ts